import { AxiosApi } from "./index";

export const   sendToSign =  async ({buyerSigner, vesselSigner, apprenticeSigner, documentNumber }: {buyerSigner?: string | null, vesselSigner?: string | null, apprenticeSigner?: string, documentNumber: string })   => {

    const apiUri = "CatchCertificationSigning/SendToSign"

    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                receiver: buyerSigner, 
                vessel: vesselSigner,
                 apprentice: apprenticeSigner,
                no: documentNumber
            }
        })

        return registrations.data
    } catch (error) {
        console.log('error', error);
        throw error
    }
}

export async function getCatchSignRegisterUserApi() {
    const apiUri = "CatchCertificationSigning/RegisterUser"

    try {
        const result = await AxiosApi.get<string>(apiUri)
        return result.data
    } catch (error) {

        throw error
    }
}

export async function getCatchSignResetPasswordApi(username: string) {

    const apiUri = "CatchCertificationSigning/ResetPassword"

    try {
        const result = await AxiosApi.get<string>(apiUri, {
            params: { username }
        })
        return result.data

    } catch (error) {

        throw error
    }
}


export  async  function validateSignerApi(signer: string) {

    const apiUri = "CatchCertificationSigning/ValidateSigner"
    try {
        const result = await AxiosApi.get<{isValid: boolean}>(apiUri, {
            params: { signer }
        })
        return result.data
    } catch (error) {

        throw error
    }
}
export async function getNoteSignersApi(noteNumber: string , signerType: number) {
    const apiUri = "CatchCertificationSigning/NoteSigners"

    try {
        const result = await AxiosApi.get<{username: string, userNumber: number}[]>(apiUri, {
            params: { noteNumber, signerType }
        })
        return result.data
    } catch (error) {   
        throw error
    }
}